import type { ReactElement } from 'react';
import { User } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { UserSelectorAvatar } from '@/shared/components/user-selector/UserSelectorAvatar';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/shared/components/ui/Tooltip';

interface SignalAuthorDisplayProps {
  owner?: {
    fullName: string;
    imageUrl?: string;
  };
  size?: 'sm' | 'md';
}

const sizeConfig = {
  sm: {
    circle: 'h-6 w-6',
    icon: 'h-3.5 w-3.5',
  },
  md: {
    circle: 'h-7 w-7',
    icon: 'h-4 w-4',
  },
};

export const SignalAuthorDisplay = ({
  owner,
  size = 'sm',
}: SignalAuthorDisplayProps): ReactElement => {
  const { t } = useTranslation('knowledge');

  if (!owner) {
    const { circle, icon } = sizeConfig[size];
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div
              className={`flex ${circle} items-center justify-center rounded-full bg-gray-200`}
            >
              <User className={`${icon} text-muted-foreground`} />
            </div>
          </TooltipTrigger>
          <TooltipContent>{t('marketplace.anonymous')}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return (
    <div className="flex items-center gap-1.5">
      <UserSelectorAvatar
        fullName={owner.fullName}
        imageUrl={owner.imageUrl}
        size={size}
      />
      <span className="text-xs font-medium text-[#5c554d]">
        {owner.fullName}
      </span>
    </div>
  );
};
